import { HiChevronDoubleDown } from "react-icons/hi";
import { Link as Scroll } from "react-scroll";
import { Link } from "react-router-dom";
import "./Hero.scss";
// import CountDown from "../CountDown/CountDown";
import Theme from "../../assets/images/theme.png";
import Banner from "../Banner";

const Hero = () => {
  return (
    <>
      <section className=" hero">
        <div className="banner">
          <Banner />
        </div>
        <article className="hero__container container flex ">
          <div className="hero__container--contents">
            <img src={Theme} alt="theme" />
            <p>
              In the heart of our local community, this theme embodies the
              essence of our university community. It signifies the convergence
              of diverse minds, cultures, and perspectives, all united in their
              pursuit of knowledge and progress. In our rapidly evolving world,
              where ideas know no boundaries and change is constant, "Minds in
              Motion" stands as a beacon of relevance and inspiration. This
              theme is a testament to the indomitable human spirit, which
              thrives on innovation, diversity, and adaptability.
            </p>
            {/* <CountDown /> */}

            <div className="hero__container--contents-button">
              <Link to="/ticket">
                <button className="hero-btn">Buy Ticket</button>
              </Link>
            </div>
          </div>

          <Scroll
            to="next-section"
            smooth={true}
            duration={100}
            delay={0}
            offset={100}
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="scroll-btn">
              <HiChevronDoubleDown />
              <span>Scroll Down</span>
            </div>
          </Scroll>
        </article>
      </section>
    </>
  );
};

export default Hero;
